import { ContactUs } from '@/features/support';
import styles from './KycFailedPage.module.scss';
import { noEntry } from '@/assets/images/emojis';
import { useKycSignalR } from '../../hooks/useKycSignalR';
import { useKyc } from '../../hooks/useKyc';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { routes } from '@/routes/routes';

function KycFailedPage() {
  useKycSignalR();
  const { isKycInvalid, isKycInProgress } = useKyc();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isKycInvalid && !isKycInProgress) {
      navigate(routes.kyc.base);
    }
  }, [isKycInvalid, isKycInProgress]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.failureSection}>
          <img src={noEntry} alt="No entry emoji" className={styles.emoji} />
          <h1 className={styles.title}>Identitatea nu a fost confirmată</h1>
          <p className={styles.description}>
            Din păcate, nu am putut confirma identitatea automat. Te rugăm să
            contactezi echipa de suport pentru o validare manuală.
          </p>
        </div>

        <ContactUs />
      </div>
    </div>
  );
}

export default KycFailedPage;
